// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2-4Jd","inputWrap":"Table_inputWrap__3nUO_","col":"Table_col__3zG7M","bmiTooltip":"Table_bmiTooltip__OJ5Eb"};